import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatSeparator',
  standalone: true,
})
export class FormatSeparatorPipe implements PipeTransform {
  public transform(value: number, decimalSeparator: string = '.', fixed?: number): string {
    if (value === null || isNaN(value)) return '';

    let formatted: string = fixed !== undefined ? this.formatFixed(value, fixed) : value.toString();

    if (decimalSeparator === ',') {
      formatted = formatted.replace('.', ',');
    }

    return formatted;
  }

  private formatFixed(value: number, fixed: number): string {
    const fixedValue: string = value.toFixed(fixed);

    if (Number(fixedValue) % 1 === 0) {
      return Math.round(value).toString();
    }

    return fixedValue.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.$/, '');
  }
}
